/* eslint no-underscore-dangle: 0 */
import { PREMIUM_BANNNER_CACHE, PREMIUM_BANNNER_SUCCESS, PREMIUM_BANNNER_REQUEST, PREMIUM_BANNNER_FAIL } from 'actionTypes';

const initialState = {
  isPremiumBannerVisible: false,
  premiumBanner: {},
};

export default function(state = initialState, action) {
  switch (action.type) {
    case PREMIUM_BANNNER_CACHE:
    case PREMIUM_BANNNER_SUCCESS: {
      return {
        ...state,
        isPremiumBannerVisible: true,
        premiumBanner: action.payload,
      };
    }
    case PREMIUM_BANNNER_REQUEST: {
      return {
        ...state,
      };
    }
    case PREMIUM_BANNNER_FAIL: {
      return {
        ...state,
        isPremiumBannerVisible: true,
      };
    }
    default: {
      return state;
    }
  }
}
